
<app-header></app-header>
<!-- Main Header Account -->
<app-right-side></app-right-side>
<link
rel="stylesheet"
data-purpose="Layout StyleSheet"
title="Web Awesome"
href="/css/app-wa-86cd56275caec687041f80b17dc62e32.css?vsn=d"
>

<link
  rel="stylesheet"
  href="https://site-assets.fontawesome.com/releases/v5.15.4/css/all.css"
>

<div class="container">
    <div class="row">
        <div class="col col-xl-9 order-xl-2 col-lg-9 order-lg-2 col-md-12 order-md-1 col-sm-12 col-12" style="top:0px">
            <div class="ui-block"  style="background-color: var(--backgroundpost-color); color: var(--text-color);">
                <div class="ui-block-title">
                    <h6 class="title h2" style="color: var(--text-color);"><i class="fad fa-user-clock"></i>&nbsp;Friend Requests</h6>

                </div>

                <div *ngIf="friends.length === 0" class="ui-block-title">
                    <h6 class="display-message" style="color: var(--text-color);"> No Requests Found! </h6>

                </div>



                <!-- Notification List Frien Requests -->
                    <br>
                    <div class="row">
                    <div *ngFor="let friend of friends" class="col-lg-4 col-xl-4 col-md-6 col-sm-12 col-12">
                        <div style="padding: 10px; text-align: center; border: 3px solid var(--text-color); position: relative; left:5px; background-color: black; color:#fff; border-radius: 20px;">
                        <div class="author-thumb" style="height: 60px;">
                            <a routerLink="/friend-about" [queryParams]="{'id': friend.user.id}"><img *ngIf="!friend.user.avatar" src="../../../assets/img/author-main1.webp" width="50" height="50" alt="author"> </a>
                            <a routerLink="/friend-about" [queryParams]="{'id': friend.user.id}"><img *ngIf="friend.user.avatar" alt="author" [src]="friend.user.avatar" class="avatar" width="50" height="50"> </a>
                        </div>
                        <div class="notification-event">
                            <a routerLink="/friend-about" [queryParams]="{'id': friend.id,'role': 'User'}" class="h4 notification-friend" style="color: #fff;">{{ friend.user.fullName | titlecase}}</a>
                            <div style="background-color: chocolate; border-radius: 10px; width: 200px; text-align: center; margin: 0px auto; padding: 8px;"><i class="fad fa-user-clock"></i> &nbsp;{{friend.status}} &nbsp;( {{calculateDiff(friend.created_at)}} )</div>
                            <br><br>
                            <a (click)="acceptRequest(friend.friend_id)" class="accept-request" style="background-color: darkolivegreen; width: 50px; height: 37px; font-size: 20px;">
                                <i class="fa fa-check"></i>
                            </a>
                            <a (click)="declineRequest(friend.friend_id)" class="accept-request request-del" style="background-color: brown; width: 50px; height: 37px; font-size: 20px;">
                                <i class="fa fa-times"></i>
                            </a>
                        </div></div>
                    </div></div>
                    <br>
                <!-- ... end Notification List Friend Requests -->
            </div>

        </div>

        <div class="col col-xl-3 order-xl-1 col-lg-3 order-lg-1 col-md-12 order-md-2 col-sm-12 col-12 responsive-display-none" style="top:0px">
            <div class="ui-block" style="background-color: var(--backgroundpost-color); color: var(--text-color);">

                <!-- Your Profile  -->

                <div class="your-profile" >
                    <!-- <div class="ui-block-title ui-block-title-small">
                        <h6 class="title">Your PROFILE</h6>
                    </div> -->

                    <div id="accordion" role="tablist" aria-multiselectable="true" >
                        <div class="card" style="background-color: var(--backgroundpost-color); color: var(--text-color);">
                            <div class="card-header" role="tab" id="headingOne">
                                <h6>
                                    <a data-toggle="collapse" data-parent="#accordion" href="#collapseOne" aria-expanded="true" aria-controls="collapseOne" dir="ltr">
                                        <i class="fad fa-user-cog"></i>&nbsp;Profile Settings
                                    </a>
                                </h6>
                            </div>

                            <div id="collapseOne" class="collapse show" role="tabpanel" aria-labelledby="headingOne">
                                <ul class="your-profile-menu">
                                    <li>
                                        <a routerLink="/profile-setting" style="color: var(--text-color);"><i class="fad fa-id-card"></i>&nbsp;Personal Information</a>
                                    </li>

                                    <li>
                                        <a routerLink="/change-password" style="color: var(--text-color);"><i class="fad fa-lock"></i>&nbsp;Change Password</a>
                                    </li>
                                    <li>
                                        <a routerLink="/hobbies-and-intrests" style="color: var(--text-color);"><i class="fad fa-icons"></i>&nbsp;Hobbies and Interests</a>
                                    </li>

                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="ui-block-title">
                        <a routerLink="/friend-requests" class="h6 title" style="color: var(--text-color);"><i class="fad fa-user-clock"></i>&nbsp;Friend Requests</a>
                        <!-- <a routerLink="/friend-requests" class="items-round-little bg-blue">4</a> -->
                    </div>
                    <!-- <div class="ui-block-title ui-block-title-small">
						<h6 class="title">FAVOURITE PAGE</h6>
					</div>
					<div class="ui-block-title">
						<a href="javascript:void(0);" class="h6 title">Create Fav Page</a>
					</div>
					<div class="ui-block-title">
						<a href="javascript:void(0);" class="h6 title">Fav Page Settings</a>
					</div> -->
                </div>

                <!-- ... end Your Profile  -->

            </div>
        </div>
    </div>
</div>

<!-- ... end Your Account Personal Information -->